module.exports = __webpack_public_path__ + "assets/cc0963a31cdbfd51f5d04c54dc328562.mp3";